import React, { useEffect, useRef } from 'react';

import HeaderTable from '../../ProgramsTable/HeaderTable';
import { Box, CircularProgress } from '@mui/material';

import styles from './styles.module.scss';
import { defaultProps, propTypes } from './types';

const DetailsTable = props => {
  const { setLoading, loading, hide, list, isLoading, sortByKey, sortDescStates } = props;
  if (hide) return null;
  if (isLoading) return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress />
      </Box>
    </>
  );
  if (!list?.length && !isLoading) return <>No se encontraro información</>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeaderTable
          onClick={() => sortByKey('name')}
          title="Nombre del candidato"
          iconDesc={sortDescStates?.nameSortDesc}
        />

        <HeaderTable onClick={() => sortByKey('email')} title="Correo" iconDesc={sortDescStates?.emailSortDesc} />

        <HeaderTable onClick={() => sortByKey('phone')} title="Teléfono" iconDesc={sortDescStates?.phoneSortDesc} />

        <HeaderTable onClick={() => sortByKey('error')} title="Error" iconDesc={sortDescStates?.errorSortDesc} />
      </div>

      <div className={styles.body}>
        {list.map((historyDetail, index) => {
          const { name, email, phone, error } = historyDetail;
          return (
            <div className={styles.row} key={`${name}-${index}`}>
              <div className={styles.ml10}>{name}</div>
              <div>{email}</div>
              <div>{phone}</div>
              <div className={styles.fail}>{`${error.message}`}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

DetailsTable.prototype = propTypes;
DetailsTable.defaultProps = defaultProps;

export default DetailsTable;
